var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutMission3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_2499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9199 8.625H11.0957",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4566 21.3306C24.2767 21.5384 24.0542 21.7051 23.8041 21.8193C23.5541 21.9336 23.2825 21.9927 23.0076 21.9927C22.7327 21.9927 22.4611 21.9336 22.211 21.8193C21.961 21.7051 21.7385 21.5384 21.5586 21.3306L11.5613 9.79421C11.2745 9.46322 11.1098 9.04403 11.0944 8.60639C11.0791 8.16874 11.2141 7.73904 11.4769 7.38879L15.7166 1.72504C15.8951 1.487 16.1266 1.29379 16.3928 1.16072C16.6589 1.02765 16.9524 0.958374 17.2499 0.958374H28.7499C29.0475 0.958374 29.3409 1.02765 29.6071 1.16072C29.8732 1.29379 30.1047 1.487 30.2833 1.72504L34.5383 7.38879C34.8011 7.73904 34.9361 8.16874 34.9207 8.60639C34.9054 9.04403 34.7407 9.46322 34.4539 9.79421L24.4566 21.3306Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7993 39.2916H39.2993V45.0416H27.7993V39.2916Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3749 39.2917V36.3573C37.3749 36.3573 42.3678 31.4142 44.4781 29.3136C44.6569 29.1353 44.7987 28.9235 44.8954 28.6903C44.9921 28.4571 45.0418 28.2071 45.0416 27.9547V13.2979C45.0416 13.2979 40.2499 11.5595 40.2499 24.9167L34.5593 30.6073L35.878 24.8573C36.5354 22.1012 34.0169 20.9243 32.6427 23.0595C31.437 25.4962 30.4548 28.0373 29.7083 30.6514V39.2917",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71606 39.2916H18.2161V45.0416H6.71606V39.2916Z",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62492 39.2917V36.3573C8.62492 36.3573 3.908 31.3893 1.5965 29.2963C1.39666 29.1174 1.2366 28.8986 1.12666 28.6539C1.01671 28.4093 0.959342 28.1443 0.958252 27.8761V13.2979C0.958252 13.2979 5.74992 11.5595 5.74992 24.9167L11.4405 30.6073L10.1218 24.8573C9.4625 22.1012 11.9829 20.9243 13.3572 23.0595C14.5628 25.4962 15.545 28.0373 16.2916 30.6514V39.2917",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3665 1.17871L22.6915 21.965",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.649 1.17871L23.4026 21.9515",
    stroke: "#3B9FBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_2499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMission3);
export default __webpack_public_path__ + "static/media/aboutMission3.ee36bec73e54cbcbed49bfb22e5914d5.svg";
export { ForwardRef as ReactComponent };